"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagOM = function FlagOM(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-87.07,146.36h-98.87A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06h98.87Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-164.16-63.47l-1.14.15v5l1.14.28Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-146.76-53.88c-1.05-.09-2.66-.24-4.58-.48L-163.4-43.63a41.31,41.31,0,0,1,4.21.8c3.1-2.71,7.26-6.41,12.43-11.05Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-128.61-70.94v-1H-150v1.54h21.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-144.45-101.55c0,1.51,2.27,2.78,5,2.78s5-1.27,5-2.78-2.27-2.78-5-2.78-5,1.27-5,2.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-149.09-64.15c-4.83,0-9.65.16-13.59.53v5.94c4.62,1,10,1.75,13.59,2.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-174-34.84a17,17,0,0,0,8.94-3c.88-.69,2.39-2,4.5-3.79-1.43-.29-3.84-.65-5.12-.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-146.34-73.45v-2.7l-1.11-1.66-3.29,2.4c.66,1.12,1.08,1.83,1.15,2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-171.62-61.26s0,.15.13.36c.61.78,2.38,1.53,4.72,2.21v-4.42c-2.82.47-4.66,1.09-4.85,1.85Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-134-63.36V-69h-10.83v13.69h2.75A8.09,8.09,0,0,0-134-63.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-151.45-83.72c-5.8-8.55-12-17.54-13.51-19.32a42.62,42.62,0,0,0,2,5.09c1.58,3.61,5.41,10.54,8.57,16.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-153.7-80.56l2.22,3.86,3.21-2.32-2.35-3.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-146.34-55.31v-8.8l-1.28,0v8.73l1.28.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "49.14",
    y: "42",
    width: "10.84",
    height: "1.54",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-119-73.54v.09h.55a.73.73,0,0,1,.73.74v3a.73.73,0,0,1-.73.73H-119v.09a.74.74,0,0,0,.73.74h12.4a.74.74,0,0,0,.74-.74v-4.66a.74.74,0,0,0-.74-.73h-12.4a.73.73,0,0,0-.73.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-105.09-34.89l-8.27-7.58c-1.29.17-3.69.53-5.12.82q3.23,2.81,4.49,3.79a16.41,16.41,0,0,0,8.9,3Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-122.09-71.47v1h2.94V-72h-2.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-119.84-42.82a36.12,36.12,0,0,1,4.23-.81l-17.78-15.86a9.43,9.43,0,0,1-2,2.88l.47.42q9.66,8.65,15.06,13.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-159.65-68.88V-69h-.56a.73.73,0,0,1-.73-.73v-3a.74.74,0,0,1,.73-.74h.55v-.09a.73.73,0,0,0-.73-.73h-12.4a.73.73,0,0,0-.73.73v4.66a.73.73,0,0,0,.73.74h12.4a.74.74,0,0,0,.74-.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-156.53-70.94v-1h-2.94v1.54h2.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-128.29-75.41l-3.28-2.4c-.34.5-.66,1-1,1.47v2.89h3.13l1.14-2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-143.88-85.5H-135l-2-2.17h-5Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "49.14",
    y: "39.03",
    width: "10.84",
    height: "1.49",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-139.49-97.3a9.91,9.91,0,0,1-2-.23v8.31h4.08v-8.32a9.61,9.61,0,0,1-2.06.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-144.86-76.45h10.79a.66.66,0,0,1,0-.28V-78h-10.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-130.75-79l3.21,2.32,2.22-3.86-3.08-1.94L-130.75-79Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "49.14",
    y: "48.02",
    width: "10.84",
    height: "1.54",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-124.59-81.83c3.16-5.58,7-12.51,8.57-16.12a40.69,40.69,0,0,0,2-5.1c-1.48,1.74-7.7,10.76-13.51,19.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-103-35l-9.59-8.79a.71.71,0,0,0-.59-.19l-.51.07,0,0-19.1-17a9.2,9.2,0,0,0,.31-2.36V-69h4.63a3.25,3.25,0,0,0,2.58,1.29A3.24,3.24,0,0,0-122.77-69h2.34v.09a2.2,2.2,0,0,0,2.2,2.21h12.4a2.2,2.2,0,0,0,2.2-2.21v-4.66a2.2,2.2,0,0,0-2.2-2.2h-12.4a2.21,2.21,0,0,0-2.2,2.2v.09h-2.34a3.25,3.25,0,0,0-2.57-1.28,3.23,3.23,0,0,0-2.09.77c2.47-4.24,10.25-17.68,12.75-23.4,2.68-6.15,2.47-6.94,1.84-7.45s-1.52.08-1.84.31c-1.23.89-13.15,18.51-17.88,25.53v-5.8s0,0,0,0a.7.7,0,0,0-.36-.58l-3-3.36V-98c1.76-.75,2.9-2.05,2.9-3.56,0-2.38-2.83-4.25-6.43-4.25s-6.43,1.87-6.43,4.25c0,1.52,1.16,2.83,2.94,3.58v9.27l-3,3.3a.74.74,0,0,0-.38.63v6c-4.63-6.88-16.76-24.82-18-25.72-.32-.23-1.17-.85-1.84-.31s-.85,1.3,1.83,7.45c2.42,5.54,9.79,18.32,12.51,23a3.28,3.28,0,0,0-1.43-.35,3.28,3.28,0,0,0-2.58,1.29h-2.33v-.09a2.21,2.21,0,0,0-2.21-2.2h-12.4a2.21,2.21,0,0,0-2.2,2.2v4.66a2.21,2.21,0,0,0,2.2,2.21h12.4a2.21,2.21,0,0,0,2.2-2.21V-69h2.34a3.25,3.25,0,0,0,2.58,1.29A3.22,3.22,0,0,0-150.7-69h4.36v3.38c-6.81-.14-25.67-.16-26.7,4a1.8,1.8,0,0,0,.39,1.61c2,2.55,12.06,4.41,19.37,5.39l-12,10.66,0,0-.52-.07a.72.72,0,0,0-.59.19L-176-35a.73.73,0,0,0-.07,1,3.06,3.06,0,0,0,2.2.57,17.87,17.87,0,0,0,9.72-3.28c2.26-1.77,8.53-7.27,18.64-16.34l.85-.77h2.53a9.52,9.52,0,0,0,5.61-1.84l.62.56c11.63,10.41,18.7,16.6,21,18.39a17.73,17.73,0,0,0,9.71,3.28A3,3,0,0,0-103-34a.72.72,0,0,0-.06-1Zm-41.82-20.28V-69H-134v5.61a8.09,8.09,0,0,1-8.08,8.08Zm-21.91-3.41c-2.34-.68-4.11-1.43-4.72-2.21-.16-.21-.14-.32-.13-.36.19-.76,2-1.38,4.85-1.85ZM-165-103c1.51,1.78,7.71,10.77,13.51,19.32l-3,1.89c-3.16-5.58-7-12.51-8.57-16.12a42.62,42.62,0,0,1-2-5.09Zm17.51,25.23,1.11,1.66v2.7h-3.25c-.07-.13-.49-.84-1.15-2Zm-4,1.11c-.64-1.09-1.39-2.41-2.22-3.86l3.08-1.94,2.35,3.48Zm5.14,12.59v8.8l-1.28-.09v-8.73l1.28,0Zm-16.34.49c3.94-.37,8.76-.55,13.59-.53v8.6c-3.57-.38-9-1.14-13.59-2.13Zm-2.62.3,1.14-.15V-58l-1.14-.28Zm14,9c1.92.24,3.53.39,4.58.48-5.17,4.64-9.33,8.34-12.43,11.05a36.41,36.41,0,0,0-4.21-.8Zm-9.2,12.71c-2.11,1.84-3.62,3.1-4.5,3.79a16.87,16.87,0,0,1-8.94,3l8.32-7.63c1.28.17,3.69.53,5.12.82ZM-150-70.44V-72h21.4v1.54Zm15.48-31.11c0,1.51-2.27,2.78-5,2.78s-5-1.27-5-2.78,2.27-2.78,5-2.78,5,1.27,5,2.78Zm-10.33,22.09V-81H-134v1.54ZM-134-78v1.26a.86.86,0,0,0,0,.28h-10.79V-78Zm-10.83-4.48V-84H-134v1.5Zm7.9-5.2,2,2.17h-8.88l1.95-2.17Zm-4.55-1.55v-8.31a9.91,9.91,0,0,0,2,.23,9.61,9.61,0,0,0,2.06-.24v8.32ZM-144.86-75H-134v1.54h-10.83Zm28.84-23c-1.58,3.61-5.41,10.54-8.57,16.12l-3-1.89c5.81-8.57,12-17.59,13.51-19.33a40.69,40.69,0,0,1-2,5.1Zm-7.54,26.48v.53a1.79,1.79,0,0,1-1.79,1.79,1.79,1.79,0,0,1-1.79-1.79v-.53a1.79,1.79,0,0,1,1.79-1.79,1.79,1.79,0,0,1,1.79,1.79Zm-4-5.23L-130.75-79l2.35-3.48,3.08,1.94-2.22,3.86Zm-5,.36c.33-.48.65-1,1-1.47l3.28,2.4-1.14,2h-3.13Zm-.83,16.85,17.78,15.86a38.75,38.75,0,0,0-4.23.8q-5.39-4.71-15.06-13.36l-.47-.42a9.43,9.43,0,0,0,2-2.88Zm20,17,8.27,7.58a16.36,16.36,0,0,1-8.89-3q-1.27-1-4.5-3.79c1.43-.29,3.83-.65,5.12-.82Zm8.27-31.07v4.66a.74.74,0,0,1-.73.74h-12.41a.74.74,0,0,1-.73-.74V-69h.55a.73.73,0,0,0,.73-.73v-3a.73.73,0,0,0-.73-.74H-119v-.09a.73.73,0,0,1,.73-.73h12.4a.74.74,0,0,1,.74.73Zm-14.06,3.1h-2.94V-72h2.94Zm-54.37,1.56v-4.66a.73.73,0,0,1,.73-.73h12.4a.73.73,0,0,1,.73.73v.09h-.55a.74.74,0,0,0-.73.74v3a.73.73,0,0,0,.73.73h.55v.09a.73.73,0,0,1-.73.74h-12.4a.73.73,0,0,1-.73-.74Zm14.05-3.1h2.94v1.54h-2.94Zm8,1a1.79,1.79,0,0,1-1.79,1.79,1.79,1.79,0,0,1-1.79-1.79v-.53a1.79,1.79,0,0,1,1.79-1.79,1.79,1.79,0,0,1,1.79,1.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#d23741"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagOM;
exports["default"] = _default;